// Add as we go
// Reference: https://github.com/moneysmartco/cargo-vue/blob/master/src/icons.js

import Vue from 'vue';
import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faCheck as falCheck,
  faFileSignature as falFileSignature,
  faLongArrowRight as falLongArrowRight,
  faBars as falBars,
  faTimes as falTimes,
} from '@fortawesome/pro-light-svg-icons';

import {
  faArrowRight as farArrowRight,
} from '@fortawesome/pro-regular-svg-icons';


import {
  faCaretRight as fasCaretRight,
} from '@fortawesome/pro-solid-svg-icons';

library.add(
  falCheck,
  falFileSignature,
  falLongArrowRight,
  falBars,
  falTimes,
  farArrowRight,
  fasCaretRight,
)

dom.watch();

Vue.component('fa', FontAwesomeIcon);